// src/services/loginTelemetry.ts
// Fire-and-forget login telemetry → /api/log-login (Vercel Function).
// Never blocks or breaks login: no await at the call site, swallows every error.
import type { Session } from '@supabase/supabase-js';

/**
 * Tentative de connexion en échec. Aucun jeton disponible (l'authentification
 * vient d'échouer) : le serveur écrit en service_role et déduit l'IP des
 * en-têtes. Fire-and-forget, comme le succès : ne doit jamais gêner l'UI de login.
 */
export async function logLoginFailure(email: string, reason: string): Promise<void> {
  try {
    if (!email) return;
    await fetch('/api/log-login', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        failed: true,
        email,
        reason,
        ua: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      }),
    });
  } catch {
    /* jamais bloquant */
  }
}

export async function logLoginEvent(session: Session | null): Promise<void> {
  try {
    const token = session?.access_token;
    if (!token) return;
    await fetch('/api/log-login', {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        ua: typeof navigator !== 'undefined' ? navigator.userAgent : null,
      }),
    });
  } catch {
    /* never block login */
  }
}
